var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullScreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M12.149 1h3.43M15.578 4.43V1M15.578 12.148v3.43M12.148 15.579h3.43M4.43 15.579H1M1 12.148v3.43M1 4.43V1M4.43 1H1M15.579 15.579l-5.146-5.146M6.145 6.145 1 1M6.145 10.433 1 15.58M15.579 1l-5.146 5.145"
})));
export default SvgFullScreen;